import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import CcmDetailsIcon from 'components/atoms/icons/ccmDetailsIcon';
import RpmCcmDetailsIcon from 'components/atoms/icons/rpmCcmDetailsIcon';
import classNames from 'classnames';

import s from './styles.module.scss';
import { formatNumber } from './utils';

import type { IProviderDashboardCcmDetails } from './types';

interface ICcmDetailsCardProps {
  data?: IProviderDashboardCcmDetails;
  isLoading?: boolean;
}

export const CcmDetailsCard: React.FC<ICcmDetailsCardProps> = ({
  data,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const totalBillableCodes = data?.totalBillableCodes;

  const billableCodeItems: { labelKey: string; total: number | null }[] = [
    { labelKey: 'labels.code99490', total: totalBillableCodes?.[99490] ?? 0 },
    { labelKey: 'labels.code99439', total: totalBillableCodes?.[99439] ?? 0 },
    {
      labelKey: 'labels.code99439_60',
      total: totalBillableCodes?.['99439_60'] ?? 0,
    },
    {
      labelKey: 'labels.code99489',
      total: totalBillableCodes?.[99489] ?? null,
    },
  ];

  return (
    <div className={s.reportCard}>
      <div className={s.reportCardHeader}>
        <span className={s.reportCardIcon}>
          <CcmDetailsIcon />
        </span>
        <span>{t('labels.ccmDetails')}</span>
      </div>
      <BaseSpinWrapper spinning={isLoading}>
        <div className={s.reportCardBody}>
          <div className={s.detailSection}>
            <h4 className={s.detailSubtitle}>
              {t('labels.totalBillableCodes')}
            </h4>
            <div className={s.codeTableRow}>
              <div className={s.codeTableGroup}>
                {billableCodeItems.map((item) => (
                  <div key={item.labelKey} className={s.codeTableCell}>
                    <div className={s.codeTableHeader}>
                      <RpmCcmDetailsIcon />
                      <span>{t(item.labelKey as never)}</span>
                    </div>
                    <div
                      className={classNames(s.codeTableValue, {
                        [s.codeTableValueGreen]:
                          item.total !== null && item.total > 0,
                      })}
                    >
                      {item.total === null ? '-' : formatNumber(item.total)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </BaseSpinWrapper>
    </div>
  );
};
